class AccordionManager {
  constructor() {
    this.initializedSections = new Set();
  }

  initSection(sectionId) {
    if (this.initializedSections.has(sectionId)) return;
    const sectionEl = document.querySelector(
      `[data-accordion-section="${sectionId}"]`
    );
    if (!sectionEl) return;

    // Initialize closed
    sectionEl.querySelectorAll(".accordion-collapse").forEach((c) => {
      c.style.height = "0px";
      c.classList.remove("show", "collapsing");
    });
    sectionEl.querySelectorAll("[data-accordion-toggle]").forEach((b) => {
      b.setAttribute("aria-expanded", "false");
    });

    // Delegated click
    sectionEl.addEventListener("click", (evt) => {
      const button = evt.target.closest("[data-accordion-toggle]");
      if (!button || !sectionEl.contains(button)) return;
      this.handleAccordion(button, sectionEl);
    });

    this.initializedSections.add(sectionId);
  }

  handleAccordion(button, sectionEl) {
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    const targetId = button.getAttribute("aria-controls");
    const targetCollapse = document.getElementById(targetId);
    if (!targetCollapse) return;

    // prevent double-click mid animation
    if (targetCollapse.classList.contains("collapsing")) return;

    // helper
    const onTransitionEnd = (el, cb) => {
      const handler = (e) => {
        if (e.target !== el) return;
        el.removeEventListener("transitionend", handler);
        cb();
      };
      el.addEventListener("transitionend", handler);
    };

    // Close others
    sectionEl.querySelectorAll("[data-accordion-toggle]").forEach((btn) => {
      if (btn === button) return;
      const otherId = btn.getAttribute("aria-controls");
      const other = document.getElementById(otherId);
      if (!other || !other.classList.contains("show")) return;

      btn.setAttribute("aria-expanded", "false");
      other.classList.add("collapsing");
      other.classList.remove("show");

      other.style.height = `${other.scrollHeight}px`;
      void other.offsetHeight; // force reflow
      other.style.height = "0px";

      onTransitionEnd(other, () => {
        other.classList.remove("collapsing");
        const item = btn.closest(".accordion_item-basic");
        if (item) item.classList.remove("active");
        other.style.height = "0px";
      });
    });

    // Toggle current
    if (!isExpanded) {
      button.setAttribute("aria-expanded", "true");
      const item = button.closest(".accordion_item-basic");
      if (item) item.classList.add("active");

      targetCollapse.classList.add("collapsing", "show");
      targetCollapse.style.height = "0px";
      void targetCollapse.offsetHeight;

      const h = targetCollapse.scrollHeight;
      targetCollapse.style.height = `${h}px`;

      onTransitionEnd(targetCollapse, () => {
        targetCollapse.classList.remove("collapsing");
        // keep numeric px value, not auto
        targetCollapse.style.height = `${targetCollapse.scrollHeight}px`;
      });
    } else {
      button.setAttribute("aria-expanded", "false");
      targetCollapse.classList.add("collapsing");
      targetCollapse.classList.remove("show");

      targetCollapse.style.height = `${targetCollapse.scrollHeight}px`;
      void targetCollapse.offsetHeight;
      targetCollapse.style.height = "0px";

      onTransitionEnd(targetCollapse, () => {
        targetCollapse.classList.remove("collapsing");
        const item = button.closest(".accordion_item-basic");
        if (item) item.classList.remove("active");
        targetCollapse.style.height = "0px";
      });
    }
  }
}

// Expose initializer
const accordionManager = new AccordionManager();
window.initAccordionSection = (sectionId) =>
  accordionManager.initSection(sectionId);
